<template>
  <div class="row">
    <div class="col-xs-12">
      <MarketingBreakdownTable
        title="Inquiries From Your Website"
        test-id="marketing-report-website-leads"
        share-label="Share of Inquiries"
        :rows="rows"
        :name-columns="columns"
        empty-text=""
      >
        <p class="text-muted" data-testid="marketing-report-website-leads-explanation">
          Contact forms sent from your website, by where the visitor came from. Orders and order value are
          everything the resulting students have bought so far, including orders your staff entered, so they
          can fall outside these dates. The rest of this page counts shop orders only, so the totals won't match.
        </p>
        <p data-testid="marketing-report-website-leads-summary">
          Inquiries in these dates: {{ leads.leads.toLocaleString() }}.
          Became students: {{ leads.students.toLocaleString() }}.
        </p>
      </MarketingBreakdownTable>
    </div>
  </div>
</template>

<script>
import MarketingBreakdownTable from './MarketingBreakdownTable.vue';
import { CHANNEL_LABELS } from './marketingChannels';

export default {
  name: 'MarketingWebsiteLeads',
  components: { MarketingBreakdownTable },
  props: {
    leads: { type: Object, required: true }
  },
  data: function() {
    return {
      columns: [
        { key: 'channel', label: 'Channel' },
        { key: 'leads', label: 'Inquiries' },
        { key: 'students', label: 'Became Students' }
      ]
    };
  },
  computed: {
    rows: function() {
      return this.leads.by_channel.map(function(row) {
        return Object.assign({}, row, { channel: CHANNEL_LABELS[row.channel] });
      });
    }
  }
};
</script>
